// The founder's welcome DM to a freshly approved talent, sent by hand from
// the company Instagram (Instagram allows no automated first message to
// someone who never messaged the business, so the app copies the text and
// opens the thread; the founder pastes and sends).

/** The company Instagram handle the welcome DM must be sent from. */
export const COMPANY_INSTAGRAM = "request_app_official";

/** "DJ Nova" stays "DJ Nova"; "Susu Park" becomes "Susu". */
export function greetingNameFor(name: string): string {
  const trimmed = (name || "").trim();
  if (!trimmed) return "there";
  const [first] = trimmed.split(/\s+/);
  return /^dj$/i.test(first) ? trimmed : first;
}

export function buildWelcomeDm(name: string): string {
  return [
    `Hey ${greetingNameFor(name)}! 🎉 You're officially approved — welcome to Request App.`,
    "You're live and can take paid requests from your very next set. Put your QR code where the crowd can see it and let them do the rest.",
    "Questions, ideas, or a wild request story? Message us anytime — a real human reads every one.",
    "Go get paid to play 🎧",
  ].join("\n\n");
}

/** Strips "@" and whitespace; empty when the talent gave no handle. */
export function cleanHandle(instagram?: string | null): string {
  return (instagram || "").trim().replace(/^@+/, "");
}

/** Instagram's official "message me" link: opens the DM thread with that account. */
export function igDmUrl(handle: string): string {
  return `https://ig.me/m/${encodeURIComponent(handle)}`;
}

export function igProfileUrl(handle: string): string {
  return `https://instagram.com/${encodeURIComponent(handle)}`;
}
